(function (ko, jQuery, window) {

    if (typeof (jQuery) === "undefined") { return; }
    if (typeof (window.Cookies) === "undefined") { return; }

    ko.extenders.cookie = function (target, key) {
        var initialValue = target();
        if (key && Cookies.get(key) !== null) {
            try {
                initialValue = JSON.parse(Cookies.get(key));
                //console.log("cookie: " + Cookies.get(key));
                //console.log("initialValue: " + (initialValue));
                //console.log("json.parse: " + JSON.parse(Cookies.get(key)));
                //initialValue = Cookies.get(key);
            } catch (e) {
            }
        }

        target(initialValue);

        target.subscribe(function (newValue) {
            Cookies.set(key, ko.toJSON(newValue));
        });


        return target;
    };
})(ko, jQuery, window);